import placeholderImage from "@/assets/placeholder.svg";

export const getPlaceholderImage = () => {
    return placeholderImage;
};
